import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "./AuthContext";

const ShopCtx = createContext(null);
const load = (k, d) => {
  try {
    return JSON.parse(localStorage.getItem(k)) ?? d;
  } catch (e) {
    return d;
  }
};

export function ShopProvider({ children }) {
  const { user } = useAuth();
  const [settings, setSettings] = useState({});
  const [categories, setCategories] = useState([]);
  const [cart, setCart] = useState(() => load("seed_cart", []));
  const [wishlist, setWishlist] = useState(() => load("seed_wish", []));
  const [cartOpen, setCartOpen] = useState(false);
  const [coupon, setCoupon] = useState(() => localStorage.getItem("seed_coupon") || "");

  useEffect(() => {
    api.get("/public/settings").then((r) => setSettings(r.data)).catch(() => {});
    api.get("/categories").then((r) => setCategories(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    localStorage.setItem("seed_cart", JSON.stringify(cart));
  }, [cart]);
  useEffect(() => {
    localStorage.setItem("seed_coupon", coupon);
  }, [coupon]);
  useEffect(() => {
    if (user) {
      api.get("/account/wishlist").then((r) => setWishlist(r.data.ids)).catch(() => {});
    } else if (user === false) {
      setWishlist(load("seed_wish", []));
    }
  }, [user]);

  const addToCart = (p, variant = null, qty = 1, open = true) => {
    const key = `${p.id}:${variant?.id || ""}`;
    setCart((c) => {
      const ex = c.find((i) => i.key === key);
      if (ex) return c.map((i) => (i.key === key ? { ...i, qty: Math.min(20, i.qty + qty) } : i));
      return [...c, { key, product_id: p.id, variant_id: variant?.id || null, qty, name: p.name,
        variant_name: variant?.name, slug: p.slug, image: p.images?.[0]?.url, price: variant?.price ?? p.price }];
    });
    toast.success(`${p.name} added to cart`);
    if (open) setCartOpen(true);
  };
  const updateQty = (key, qty) => setCart((c) => c.map((i) => (i.key === key ? { ...i, qty: Math.max(1, Math.min(20, qty)) } : i)));
  const removeItem = (key) => setCart((c) => c.filter((i) => i.key !== key));
  const clearCart = () => {
    setCart([]);
    setCoupon("");
  };
  const toggleWish = async (pid) => {
    if (user) {
      try {
        const { data } = await api.post(`/account/wishlist/${pid}`);
        setWishlist((w) => (data.in_wishlist ? [...w, pid] : w.filter((x) => x !== pid)));
        toast.success(data.in_wishlist ? "Saved to wishlist" : "Removed from wishlist");
      } catch (e) {
        toast.error(errMsg(e));
      }
    } else {
      setWishlist((w) => {
        const n = w.includes(pid) ? w.filter((x) => x !== pid) : [...w, pid];
        localStorage.setItem("seed_wish", JSON.stringify(n));
        return n;
      });
    }
  };
  const cartCount = cart.reduce((s, i) => s + i.qty, 0);

  return (
    <ShopCtx.Provider value={{ settings, categories, cart, addToCart, updateQty, removeItem, clearCart, cartCount,
      cartOpen, setCartOpen, wishlist, toggleWish, coupon, setCoupon }}>
      {children}
    </ShopCtx.Provider>
  );
}

export const useShop = () => useContext(ShopCtx);
